import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import { Card } from "react-bootstrap";
import helper from "../../lib/helper";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors,isSubmitting },
        setError,
        reset
    } = useForm();
    const { data, mutate } = useSWR('setting', async () => await settingsModel.list())
    console.log('data------', data)
    useEffect(() => {

        reset(data?.data);
    }, [data])


    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await settingsModel.create(formData).then((response) => {
            helper.sweetalert.toast(response?.data?.message, 'success')
            // router.push('/pages')
        }).catch(error => {
            console.log('error', error)
            setError('title', { type: 'required', message: error.response?.data?.errors?.title })
            console.log(data?.errors?.title)
        })
    });

    return (
        <>
          

            <SettingsLayout title="Settings">
                <div className="tab-pane active" id="profile">

                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-12 mx-auto">
                                <h2 className="h3 mb-4 page-title">Website Settings</h2>

                            </div>
                            <Card.Header>SEO</Card.Header>
                            <form onSubmit={onSubmit}>
                                <Card.Body>

                                    <div className="col-md-12">
                                        <label className="form-label">Seo-title</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors?.seo_title && "is-invalid"}`}
                                            {...register("seo_title",)}
                                        />
                                        <div className="invalid-feedback">
                                            {errors.seo_title && errors.seo_title.message}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label className="form-label">Seo-description</label>
                                        <textarea
                                            type="text"
                                            className={`form-control ${errors?.seo_description && "is-invalid"}`}
                                            {...register("seo_description",)}
                                        />
                                        <div className="invalid-feedback">
                                            {errors.seo_description && errors.seo_description.message}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label className="form-label">Seo-keywords</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors?.seo_keywords && "is-invalid"}`}
                                            {...register("seo_keywords",)}
                                        />
                                        <div className="invalid-feedback">
                                            {errors.seo_keywords && errors.seo_keywords.message}
                                        </div>
                                    </div>
                                    <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end mt-2">Save</button>
                                </Card.Body>
                            </form>
                        </div>
                    </div>
                </div>
            </SettingsLayout>
        </>
    );
};

export default Page;

